import {
  detectTouch,
  orientation,
  windowHeightVar
} from './utilities/helpers.js'; 
import barba from './modules/barba/index.js';
// import blockviews from '../../views/blocks/**/*.js';
// import includes from '../../includes/**/*.js';


function init() {
  
  orientation();
  windowHeightVar();
  detectTouch();
  barba();
  // console.log("blockviews",blockviews);

  // Object.keys(blockviews).forEach((item) => {

  //   const module = blockviews[item]
  //   //  console.log("blockviews module", module);
  //   if (
  //     module &&
  //     Object.prototype.hasOwnProperty.call(module[item], 'default')

  //   ) {
  //     module[item].default()
  //   }

  // })

}

export default init